import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

@Injectable()
export class AuthenticationService {
  authToken:any;
  user:any;

  constructor(private http:Http) {

  }
  registerUser(user){
    let headers = new Headers();
    headers.append('Content-Type','application/json');
    return this.http.post('/users/register', user,{headers:headers})
    .map(res=>res.json());
  }

  updatedUserPassword(user){
    let headers = new Headers();
    headers.append('Content-Type','application/json');
    return this.http.put('/users/update_user', user,{headers:headers})
    .map(res=>res.json());
  }

  updateUser(user){
    let headers = new Headers();
    headers.append('Content-Type','application/json');
    return this.http.put('/users/update_user_complete', user,{headers:headers})
    .map(res=>res.json());
  }

  authenticateUser(user){
    let headers = new Headers();
    headers.append('Content-Type','application/json');
    return this.http.post('/users/authenticate', user,{headers:headers})
    .map(res=>res.json());
  }

  getProfile(){
    let headers = new Headers();
    this.loadToken();
    headers.append('Authorization', this.authToken);
    headers.append('Content-Type', 'application/json');
    return this.http.get('/users/profile',{headers:headers})
    .map(res => res.json());
  }

  isAdmin(){
      let headers = new Headers();
      this.loadToken();
      headers.append('Authorization', this.authToken);
      headers.append('Content-Type', 'application/json');
      return this.http.get('/users/profile',{headers:headers})
      .map(res => res.json());
  }

  loggedIn(){
    return tokenNotExpired('id_token');
  }

  storeUserData(token, user){
    localStorage.setItem('id_token',token);
    localStorage.setItem('user',JSON.stringify(user));
    this.authToken = token;
    this.user = user;
  }

  loadToken(){
    const token = localStorage.getItem('id_token');
    this.authToken = token;

  }

  RetrieveloadToken(){
    const token = localStorage.getItem('id_token');
    return token;

  }

  RetrieveAccount(){
    const user = localStorage.getItem('user');
    return user;

  }

  logout(){
    this.authToken = null;
    this.user = null;
    localStorage.clear();

  }

}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts